<template lang="pug">
  div
    .d-block
      h4 Starts In
    div(:id="name").countdown_small
</template>

<script>
import countdown from '@/assets/js/jquery.countdown.js';
export default {
  props: ['name', 'start'],
  mounted(){
    $('#'+this.name).countdown({ until: this.$moment(this.start).toDate() });
  }
}
</script>